import React, { useEffect } from 'react';
import "./footer.css";
import video2 from "../../Assets/video2.mp4";
import tallyLogo from '../../Assets/tally-logo-white.png';
import { FiSend, FiChevronRight } from "react-icons/fi";
import { MdOutlineTravelExplore } from 'react-icons/md';
import { AiOutlineTwitter, AiFillYoutube, AiFillInstagram } from "react-icons/ai";
import { FaTripadvisor } from "react-icons/fa";

import Aos from "aos";
import 'aos/dist/aos.css';

const Footer = () => {

  // React hooks for scroll animation
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="footer">
      <div className="videoDiv">
        <video src={video2} loop autoPlay muted type='video/mp4'></video>
      </div>

      <div className="secContent container">
        <div className="contactDiv flex">
          <div data-aos="fade-up" className="text">
            <small>დარჩი ჩვენთან</small>
            <h2>იმოგზაურე ჩვენთან ერთად</h2>
          </div>

          <div className="inputDiv flex">
            <input data-aos="fade-up" type="text" placeholder='შეიყვანეთ ელ. ფოსტის მისამართი' />
            <button data-aos="fade-up" className='btn flex' type='submit'> გაგზავნა <FiSend className='icon' /> </button>
          </div>
        </div>

        <div className="footerCard flex">
          <div className="footerIntro flex">
            <div className="logoDiv">
              <a href="#" className='logo flex'>
                <MdOutlineTravelExplore className='icon' />Tally Holidays.
              </a>
            </div>

            <div data-aos="fade-up" className="footerParagraph">
              გმადლობთ, რომ ესტუმრეთ ჩვენს სამოგზაურო გვერდს და აღმოაჩინეთ მსოფლიო ჩვენთან ერთად!
              იმედია, მიიღეთ შთაგონება და საჭირო ინფორმაცია თქვენი შემდეგი თავგადასავლის დასაგეგმად.
              ჩვენი მიზანია, რომ თქვენთვის დაუვიწყარი გამოცდილებები შევქმნათ და მოგაგროვებინოთ მომენტები, რომლებიც სამუდამოდ გაგყვებათ.
              განსაცვიფრებელი პეიზაჟებიდან დინამიურ კულტურებამდე, ჩვენ ვცდილობთ წარმოგიდგინოთ ჩვენი პლანეტის სილამაზე და მრავალფეროვნება.
              შემოგვიერთდით, რათა ერთად გავუზიაროთ მოგზაურობის საოცრებები.
              ბედნიერი მგზავრობა!
            </div>

            <div data-aos="fade-up" className="footerSocials flex">
              <AiOutlineTwitter className='icon' />
              <AiFillYoutube className='icon' />
              <AiFillInstagram className='icon' />
              <FaTripadvisor className='icon' />
            </div>
          </div>

          <div className="footerLinks grid">
            {/* პირველი ჯგუფი */}
            <div data-aos="fade-up" data-aos-duration="3000" className="linkGroup">
              <span className="groupTitle">
                ჩვენი სააგენტო
              </span>

              <li className="footerList flex">
                <FiChevronRight className='icon' />
                სერვისები
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                დაზღვევა
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                სააგენტო
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ტურიზმი
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                გადახდა
              </li>
            </div>

            {/* მეორე ჯგუფი */}
            <div data-aos="fade-up" data-aos-duration="4000" className="linkGroup">
              <span className="groupTitle">
                პარტნიორები
              </span>

              <li className="footerList flex">
                <FiChevronRight className='icon' />
                დაჯავშნა
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                მანქანის გაქირავება
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ჰოსტელების მსოფლიო
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ტრივაგო
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ტრიპადვაიზორი
              </li>
            </div>

            {/* მესამე ჯგუფი */}
            <div data-aos="fade-up" data-aos-duration="5000" className="linkGroup">
              <span className="groupTitle">
                პოპულალური ადგილები
              </span>

              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ლონდონი
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                კალიფორნია
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ინდონეზია
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ევროპა
              </li>
              <li className="footerList flex">
                <FiChevronRight className='icon' />
                ინდოეთი
              </li>
            </div>
          </div>

          <div className="footerDiv flex">
            <small>ყველა უფლება დაცულია</small>
            <a href="https://tally.ge" target='_blank'>
              <img src={tallyLogo} alt="tally" style={{
                height:'48px'
              }} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
